<template>
  <div>
    <!-- List Table -->
    <List
      :header="header"
      :data="data"
      :pagination="pagination"
      :loading="loading"
      @updatePage="updatePage"
      :moduleName="`communication.communicationChannels`"
      :moduleCreateEvent="`subHeaderDetailOpen`"
    >
      <template v-slot:item.configurations="{ item }">
        <div v-for="(value, name) in item.configurations">
          <b>{{ name }}:</b> <span class="text-muted">{{ value }}</span>
        </div>
      </template>

      <template v-slot:item.action="{ item }">
        <template v-if="item.type != 'email'">
          <DeleteButton
            icon="fad fa-trash"
            :title="$t('global.delete')"
            @click.native="openDeleteHandler(item)"
          ></DeleteButton>
        </template>
        <template v-else>
          <span class="text-muted">
            {{ $t('communication.emailRecordsCannotBeDeleted') }}</span
          >
        </template>
      </template>
    </List>

    <!-- Create Popup -->
    <DetailModal
      :title="$t('communication.createNewChannel')"
      :show="showDetail"
      @closeDetail="closeDetail()"
      @confirm="confirmModal()"
      :resetForm="resetForm"
    >
      <CreateCommunicationChannels
        :confirmModal="confirmCreate"
        @resetDetailForm="resetDetailForm"
      />
    </DetailModal>

    <DeleteOperation :url="deleteOperationUrl" @updateList="getList" />
  </div>
</template>

<script>
// Utils
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import { SET_CUSTOMHEADERPARAMS } from '@/core/services/store/customsubheader.module'
import EventBus from '@/event-bus'

// Services
import ApiService from '@/core/services/api.service'

export default {
  name: 'CommunicationChannels',
  data() {
    return {
      showDetail: false,
      resetForm: false,
      confirmCreate: false,
      loading: false,
      header: [
        { text: 'global.type', value: 'type', clicked: false, size: '1fr' },
        {
          text: 'global.configurations',
          value: 'configurations',
          clicked: false,
          size: '3fr',
        },
        { text: 'global.actions', value: 'action', size: '1fr' },
      ],
      data: [],
      pagination: {},
      meta: {},
      deleteOperationUrl: '',
    }
  },
  created() {
    this.getList()
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: 'communication.communicationChannels',
        route: '/communication/communication-channels',
      },
      {
        title: 'communication.newsChannels',
        route: '/communication/news-channels',
      },
    ])
    this.$store.dispatch(SET_CUSTOMHEADERPARAMS, {
      menuList: [
        {
          title: 'communication.communication',
        },
        {
          title: 'communication.communicationChannels',
          route: '/communication/communication-channels',
        },
      ],
      showSearch: false,
      detailPlaceholder: 'communication.createNewChannel',
    })

    EventBus.$on(`subHeaderDetailOpen`, this.listenersubHeaderDetailOpen)
  },
  beforeDestroy() {
    EventBus.$off(`subHeaderDetailOpen`, this.listenersubHeaderDetailOpen)
  },
  methods: {
    listenersubHeaderDetailOpen(payload) {
      this.showDetail = payload
    },
    getList() {
      this.loading = true

      const { current_page } = this.meta

      let $query = `communicator/user-channels?position=id|desc&page=${
        current_page ? current_page : 1
      }`
      ApiService.get($query)
        .then(({ data }) => {
          this.data = data.data
          this.pagination = data.meta ? data.meta.pagination : {}

          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.data = []
          this.loading = false
        })
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    openDeleteHandler(item) {
      this.deleteOperationUrl = `communicator/user-channels/${item.id}`
      this.$bvModal.show('modal-deleteOperation')
    },
    confirmModal() {
      this.confirmCreate = true
      setTimeout(() => {
        this.confirmCreate = false
      }, 200)
    },
    resetDetailForm(closeDetail = false) {
      if (closeDetail) {
        this.closeDetail()
        this.getList()
      }

      this.resetForm = true
      setTimeout(() => {
        this.resetForm = false
      }, 200)
    },
    closeDetail() {
      this.showDetail = false
    },
  },
  watch: {
    meta: {
      handler() {
        this.getList()
      },
      deep: true,
    },
  },
  components: {
    CreateCommunicationChannels: () =>
      import('@/components/forms/CreateCommunicationChannels'),
  },
}
</script>
